import React from 'react';
import styled from 'styled-components';
import {
  position,
  left,
  height,
  minHeight,
  minWidth,
  width,
  space,
  backgroundSize,
  backgroundPosition,
  borderRadius,
  boxShadow
} from 'styled-system';
import ProgressiveImage from 'react-progressive-bg-image';

const StyledProgressiveImage = styled(props => <ProgressiveImage blur={0} opacity={1} {...props} />)`
  background-size: cover;
  background-position: center center;
  ${backgroundSize};
  ${backgroundPosition};
  ${borderRadius};
  ${boxShadow};
  ${height};
  ${left};
  ${minHeight};
  ${minWidth};
  ${position};
  ${space};
  ${width};
`;

export default StyledProgressiveImage;
